import SHA256 from 'crypto-js/sha256';

export default function getSalt({ id }: { id: unknown }): string | null {
    if (typeof id === 'string') {
        return SHA256(id).toString();
    }

    return null;
}
